
<app-list-menu
  *ngIf="topMenuStyle === 'list'"
  [menuItems]="menuItems"
  [user]="user"
  [salesRep]="salesRep"
  [languages]="languages"
  (onToggleNavBar)="toggleNavBar()"
  (onToggleMobileUserOptions)="toggleMobileUserOptions()"
  (onItemClick)="itemClick()">
</app-list-menu>

<app-mega-menu
  *ngIf="topMenuStyle === 'mega'"
  [menuItems]="menuItems"
  [user]="user"
  [salesRep]="salesRep"
  [languages]="languages"
  (onToggleNavBar)="toggleNavBar()"
  (onToggleMobileUserOptions)="toggleMobileUserOptions()"
  (onItemClick)="itemClick()">
</app-mega-menu>
